import Vue from 'vue';
import { dateFilter } from 'vue-date-fns';

// Date from date-fns
Vue.filter('date', dateFilter);

// Custom currency
Vue.filter('currency', function(value) {
    if (null == value || isNaN(value)) {
        return '';
    }
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR'
    }).format(value);
});
